/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Aria_Downloadlist1Inputs */

const id_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh daftar`)
};

const ms_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun senarai`)
};

const da_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download liste`)
};

const de_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste herunterladen`)
};

const en_us2_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download list`)
};

const es_es2_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar lista`)
};

const es_mx2_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar lista`)
};

const fil_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-download ang listahan`)
};

const fr_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger la liste`)
};

const it_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica elenco`)
};

const hu_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista letöltése`)
};

const nl_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lijst downloaden`)
};

const no_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned liste`)
};

const pl_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz listę`)
};

const pt_br2_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de downloads`)
};

const pt_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar lista`)
};

const ro_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarcă lista`)
};

const fi_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa lista`)
};

const sv_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner lista`)
};

const vi_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống danh sách`)
};

const tr_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listeyi indir`)
};

const cs_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout seznam`)
};

const bg_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтегляне на списък`)
};

const ru_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать список`)
};

const uk_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити список`)
};

const ar_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنزيل القائمة`)
};

const hi_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची डाउनलोड करें`)
};

const th_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลดรายการ`)
};

const ja_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストをダウンロード`)
};

const zh_cn2_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载列表`)
};

const zh_hant1_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載清單`)
};

const ko_freebies_aria_downloadlist1 = /** @type {(inputs: Freebies_Aria_Downloadlist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목록 다운로드`)
};

/**
* | output |
* | --- |
* | "Download list" |
*
* @param {Freebies_Aria_Downloadlist1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_aria_downloadlist1 = /** @type {((inputs?: Freebies_Aria_Downloadlist1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Aria_Downloadlist1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_aria_downloadlist1(inputs)
	if (locale === "ms") return ms_freebies_aria_downloadlist1(inputs)
	if (locale === "da") return da_freebies_aria_downloadlist1(inputs)
	if (locale === "de") return de_freebies_aria_downloadlist1(inputs)
	if (locale === "en-US") return en_us2_freebies_aria_downloadlist1(inputs)
	if (locale === "es-ES") return es_es2_freebies_aria_downloadlist1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_aria_downloadlist1(inputs)
	if (locale === "fil") return fil_freebies_aria_downloadlist1(inputs)
	if (locale === "fr") return fr_freebies_aria_downloadlist1(inputs)
	if (locale === "it") return it_freebies_aria_downloadlist1(inputs)
	if (locale === "hu") return hu_freebies_aria_downloadlist1(inputs)
	if (locale === "nl") return nl_freebies_aria_downloadlist1(inputs)
	if (locale === "no") return no_freebies_aria_downloadlist1(inputs)
	if (locale === "pl") return pl_freebies_aria_downloadlist1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_aria_downloadlist1(inputs)
	if (locale === "pt") return pt_freebies_aria_downloadlist1(inputs)
	if (locale === "ro") return ro_freebies_aria_downloadlist1(inputs)
	if (locale === "fi") return fi_freebies_aria_downloadlist1(inputs)
	if (locale === "sv") return sv_freebies_aria_downloadlist1(inputs)
	if (locale === "vi") return vi_freebies_aria_downloadlist1(inputs)
	if (locale === "tr") return tr_freebies_aria_downloadlist1(inputs)
	if (locale === "cs") return cs_freebies_aria_downloadlist1(inputs)
	if (locale === "bg") return bg_freebies_aria_downloadlist1(inputs)
	if (locale === "ru") return ru_freebies_aria_downloadlist1(inputs)
	if (locale === "uk") return uk_freebies_aria_downloadlist1(inputs)
	if (locale === "ar") return ar_freebies_aria_downloadlist1(inputs)
	if (locale === "hi") return hi_freebies_aria_downloadlist1(inputs)
	if (locale === "th") return th_freebies_aria_downloadlist1(inputs)
	if (locale === "ja") return ja_freebies_aria_downloadlist1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_aria_downloadlist1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_aria_downloadlist1(inputs)
	return ko_freebies_aria_downloadlist1(inputs)
});
export { freebies_aria_downloadlist1 as "freebies.aria.downloadList" }